<template>
    <div class="m-auto max-w-[1200px] p-6">
        <section>
            <h2 class="mb-3 text-content-lg font-semibold">Default</h2>
            <p class="mb-3">Default tab view with dynamic tabs</p>
            <DsTabView
                :activeIndex="activeTabIndex"
                @tabChange="onTabChange"
            >
                <DsTabPanel
                    v-for="tab in tabs"
                    :key="tab.id"
                    :header="tab.title"
                >
                    <div class="flex flex-col gap-6">
                        <ul class="list-disc">
                            <li><strong>ID:</strong> {{ tab.id }}</li>
                            <li><strong>Title:</strong> {{ tab.title }}</li>
                        </ul>
                        <div><strong>Description:</strong> {{ tab.description }}</div>
                        <div class="w-30 h-30">
                            <Image
                                alt="Image"
                                preview
                                :src="`https://picsum.photos/800/400?random=${tab.id}`"
                                width="400"
                            />
                        </div>
                    </div>
                </DsTabPanel>
            </DsTabView>
        </section>
        <section class="mt-8">
            <h2 class="mb-3 text-content-lg font-semibold">Uniform tab width</h2>
            <p class="mb-3">Uniform tab width with static tabs</p>
            <DsTabView :tabs="{ uniformTabWidth: true }">
                <DsTabPanel :header="word()">
                    <p>{{ sentence(50) }}</p>
                </DsTabPanel>
                <DsTabPanel :header="word()">
                    <p>{{ sentence(50) }}</p>
                </DsTabPanel>
                <DsTabPanel :header="word()">
                    <p>{{ sentence(50) }}</p>
                </DsTabPanel>
                <DsTabPanel :header="word()">
                    <p>{{ sentence(50) }}</p>
                </DsTabPanel>
            </DsTabView>
        </section>
    </div>
</template>

<script setup lang="ts">
import { sentence, word } from '@/components/design-system/design-samples/util/word-generator';
import { DsTabPanel } from '@/components/design-system/tab/DsTabPanel';
import DsTabView from '@/components/design-system/tab/DsTabView.vue';
import Image from 'primevue/image';
import type { TabViewChangeEvent } from 'primevue/tabview';
import { ref } from 'vue';

const activeTabIndex = ref(0);
const onTabChange = (event: TabViewChangeEvent) => {
    activeTabIndex.value = event.index;
};

// Dynamically generated tabs
const tabs = ref(
    new Array(4).fill(0).map((_, i) => ({
        id: i,
        title: word(),
        description: sentence(50),
    })),
);
</script>

<style scoped>
.custom-tab-view :deep(.p-tabview-nav-link) {
    padding: 1rem 1.5rem;
    font-weight: 500;
}

.custom-tab-view :deep(.p-tabview-panel) {
    padding: 0;
}

.tab-content {
    min-height: 400px;
}
</style>
